import { render, staticRenderFns } from "./GithubVuewer.vue?vue&type=template&id=2e7dd9ea&"
import script from "./GithubVuewer.vue?vue&type=script&lang=js&"
export * from "./GithubVuewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports